import {
  IParseExportPaymentsResponse,
  ISyncExportRequest,
} from "@shared/lib/types/briefCampains";

export type ParseExportBuckets = {
  success: IParseExportPaymentsResponse[];
  failed: IParseExportPaymentsResponse[];
  cannotImport: IParseExportPaymentsResponse[];
};

export function splitParseExportRows(
  rows: IParseExportPaymentsResponse[]
): ParseExportBuckets {
  return rows.reduce<ParseExportBuckets>(
    (acc, row) => {
      if (row.status === "success" && row.vendorPaymentStatus === "Success") {
        acc.success.push(row);
        return acc;
      }
      if (row.status === "success" && row.vendorPaymentStatus === "Failed") {
        acc.failed.push(row);
        return acc;
      }
      acc.cannotImport.push(row);
      return acc;
    },
    { success: [], failed: [], cannotImport: [] }
  );
}

export function toSyncExportRequest(
  vendorPaymentBankExportId: string,
  rows: IParseExportPaymentsResponse[]
): ISyncExportRequest {
  const { success, failed } = splitParseExportRows(rows);

  return {
    vendorPaymentBankExportId,
    actionOnVendorPayments: [...success, ...failed].map((row) => ({
      vendorPaymentId: row.vendorPaymentId,
      vendorPaymentStatus: row.vendorPaymentStatus,
      rejectionReason: row.rejectionReason,
      utrNo: row.utrNo,
      paymentDate: row.paymentDate,
    })),
  };
}

export function getParseRowName(row: IParseExportPaymentsResponse): string {
  return (
    // row.vendorPayment?.vendorBilling?.name ||
    row["Beneficiary Name"] || row.vendorPaymentId || "—"
  );
}

export function getParseRowAmount(row: IParseExportPaymentsResponse): number {
  return Number(row.vendorPayment?.amount ?? row.Amount ?? 0);
}
